exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.on-this-page-link.is-active[data-v-3dbc937b]::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: -2px;\n  width: 2px;\n  background-color: var(--gl-tab-selected-indicator-color-default);\n  border-radius: 2px;\n}\n", ""]);

